module.exports = __webpack_public_path__ + "static/media/warning.beb6c873.svg";